import Fetch from '../../util/_fetch';
import { AssetParams, createUrl } from '@mss/mss-component-library';
import { sanitizeAssetForPatch, sanitizeAssetForPut } from '../utils/sanitize';

export function patchAsset(assetParams: AssetParams, body: Record<any, any>) {
  return Fetch.patch(createUrl(assetParams), {
    body: JSON.stringify(sanitizeAssetForPatch(body)),
  });
}

export function putAsset(assetParams: AssetParams, body: Record<any, any>) {
  return Fetch.put(createUrl(assetParams), {
    body: JSON.stringify(sanitizeAssetForPut(body)),
  });
}
